var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAlertActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3017 21.6248H3.2727C2.32491 21.6248 1.71111 20.6377 2.13837 19.8022L10.9152 2.68874C11.3815 1.78192 12.6844 1.76706 13.1688 2.66495L22.421 19.7755C22.8723 20.6109 22.2585 21.6248 21.2987 21.6248H21.3017Z",
    stroke: "#F01A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.287 18.6578C12.9517 18.6578 13.4905 18.1254 13.4905 17.4686C13.4905 16.8117 12.9517 16.2793 12.287 16.2793C11.6223 16.2793 11.0834 16.8117 11.0834 17.4686C11.0834 18.1254 11.6223 18.6578 12.287 18.6578Z",
    fill: "#F01A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3201 14.9739C12.0132 14.9739 11.7575 14.745 11.7334 14.4417L11.2851 9.08407C11.237 8.50727 11.6943 8.01373 12.281 8.01076C12.8647 8.00778 13.3281 8.49835 13.289 9.07217L12.9008 14.4358C12.8798 14.736 12.627 14.9709 12.3201 14.9739Z",
    fill: "#F01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertActive);
export default __webpack_public_path__ + "static/media/ico-alert-active.7c8efc8bb7ff7b249884963040d636f6.svg";
export { ForwardRef as ReactComponent };